import React from 'react';
import { useNavigate } from 'react-router-dom';
import notFoungimg from '../../assets/img/404-img.svg';

function Page404() {
    const navigate = useNavigate();
    return (
        <div className="cover-404 custom404-height">
            <div className="content-404">
                <div className="img-404">
                    <img src={notFoungimg} alt="404 img" />
                </div>
                <div className="content-otr">
                    <div className="title-404">Page Not Found</div>
                    <p>We&apos;re sorry, the page you requested could not be found Please go back to the homepage.</p>
                    <a className="go-home cursor-pointer" onClick={() => navigate(-1)}>
                        Go Home
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Page404;
